// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../.yarn/__virtual__/css-loader-virtual-7ec406d4a0/2/root/.yarn/berry/cache/css-loader-npm-6.11.0-d945f9f4c0-10c0.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../.yarn/__virtual__/css-loader-virtual-7ec406d4a0/2/root/.yarn/berry/cache/css-loader-npm-6.11.0-d945f9f4c0-10c0.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Estilos para la página de demostración BarcodeScannerDemo
 */

/* Caja de resultado del escáner */
.scanner-result-box {
    min-height: 50px;
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 2px dashed #e9ecef;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.scanner-result-box:has(.badge) {
    background-color: #e8f5e9;
    border-color: #4caf50;
    border-style: solid;
}

/* Lista de items escaneados */
.scanned-items-list {
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background-color: #fff;
}

.scanned-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #f1f1f1;
    transition: background-color 0.2s ease;
}

.scanned-item:last-child {
    border-bottom: none;
}

.scanned-item:hover {
    background-color: #f8f9fa;
}

.scanned-item .item-number {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #0ab39c, #099885);
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    margin-right: 12px;
    flex-shrink: 0;
}

.scanned-item .item-code {
    flex-grow: 1;
    font-family: 'Courier New', monospace;
    font-weight: 500;
    color: #495057;
    font-size: 14px;
    word-break: break-all;
}

.scanned-item .item-time {
    font-size: 11px;
    color: #878a99;
    margin-left: 8px;
    flex-shrink: 0;
}

/* Animación de entrada para items */
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.scanned-item {
    animation: slideIn 0.3s ease forwards;
}

/* Scrollbar personalizada para la lista */
.scanned-items-list::-webkit-scrollbar {
    width: 6px;
}

.scanned-items-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0 8px 8px 0;
}

.scanned-items-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.scanned-items-list::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Colores de fondo suaves para los headers */
.bg-soft-primary {
    background-color: rgba(64, 81, 137, 0.1) !important;
    color: #405189 !important;
}

.bg-soft-info {
    background-color: rgba(41, 156, 219, 0.1) !important;
    color: #299cdb !important;
}

.bg-soft-success {
    background-color: rgba(10, 179, 156, 0.1) !important;
    color: #0ab39c !important;
}

.bg-soft-warning {
    background-color: rgba(247, 184, 75, 0.1) !important;
    color: #f7b84b !important;
}

/* Estilos para el código preformateado */
pre {
    max-height: 150px;
    overflow-y: auto;
    font-size: 12px;
    border: 1px solid #e9ecef;
}

pre code {
    font-family: 'Courier New', monospace;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .scanner-result-box {
        min-height: 60px;
    }

    .scanned-item {
        flex-wrap: wrap;
    }

    .scanned-item .item-time {
        width: 100%;
        margin-left: 40px;
        margin-top: 4px;
    }
}

/* Efecto de hover en las cards */
.card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

/* Botones con iconos */
.btn i {
    vertical-align: middle;
}

/* Badges grandes */
.badge.fs-6 {
    font-weight: 600;
    letter-spacing: 0.5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/BarcodeScannerDemo/BarcodeScannerDemo.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,kCAAkC;AAClC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA,0CAA0C;AAC1C;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA,yCAAyC;AACzC;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA,2BAA2B;AAC3B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA,iCAAiC;AACjC;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,uBAAuB;AACvB;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,qBAAqB;AACzB","sourcesContent":["/**\n * Estilos para la página de demostración BarcodeScannerDemo\n */\n\n/* Caja de resultado del escáner */\n.scanner-result-box {\n    min-height: 50px;\n    padding: 12px 16px;\n    background-color: #f8f9fa;\n    border: 2px dashed #e9ecef;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n}\n\n.scanner-result-box:has(.badge) {\n    background-color: #e8f5e9;\n    border-color: #4caf50;\n    border-style: solid;\n}\n\n/* Lista de items escaneados */\n.scanned-items-list {\n    max-height: 250px;\n    overflow-y: auto;\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    background-color: #fff;\n}\n\n.scanned-item {\n    display: flex;\n    align-items: center;\n    padding: 10px 12px;\n    border-bottom: 1px solid #f1f1f1;\n    transition: background-color 0.2s ease;\n}\n\n.scanned-item:last-child {\n    border-bottom: none;\n}\n\n.scanned-item:hover {\n    background-color: #f8f9fa;\n}\n\n.scanned-item .item-number {\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #0ab39c, #099885);\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 600;\n    margin-right: 12px;\n    flex-shrink: 0;\n}\n\n.scanned-item .item-code {\n    flex-grow: 1;\n    font-family: 'Courier New', monospace;\n    font-weight: 500;\n    color: #495057;\n    font-size: 14px;\n    word-break: break-all;\n}\n\n.scanned-item .item-time {\n    font-size: 11px;\n    color: #878a99;\n    margin-left: 8px;\n    flex-shrink: 0;\n}\n\n/* Animación de entrada para items */\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateX(-20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.scanned-item {\n    animation: slideIn 0.3s ease forwards;\n}\n\n/* Scrollbar personalizada para la lista */\n.scanned-items-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.scanned-items-list::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 0 8px 8px 0;\n}\n\n.scanned-items-list::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n}\n\n.scanned-items-list::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n/* Colores de fondo suaves para los headers */\n.bg-soft-primary {\n    background-color: rgba(64, 81, 137, 0.1) !important;\n    color: #405189 !important;\n}\n\n.bg-soft-info {\n    background-color: rgba(41, 156, 219, 0.1) !important;\n    color: #299cdb !important;\n}\n\n.bg-soft-success {\n    background-color: rgba(10, 179, 156, 0.1) !important;\n    color: #0ab39c !important;\n}\n\n.bg-soft-warning {\n    background-color: rgba(247, 184, 75, 0.1) !important;\n    color: #f7b84b !important;\n}\n\n/* Estilos para el código preformateado */\npre {\n    max-height: 150px;\n    overflow-y: auto;\n    font-size: 12px;\n    border: 1px solid #e9ecef;\n}\n\npre code {\n    font-family: 'Courier New', monospace;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .scanner-result-box {\n        min-height: 60px;\n    }\n\n    .scanned-item {\n        flex-wrap: wrap;\n    }\n\n    .scanned-item .item-time {\n        width: 100%;\n        margin-left: 40px;\n        margin-top: 4px;\n    }\n}\n\n/* Efecto de hover en las cards */\n.card {\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n/* Botones con iconos */\n.btn i {\n    vertical-align: middle;\n}\n\n/* Badges grandes */\n.badge.fs-6 {\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
